/* Archivo: assets/ruleta-premium.js
   Propósito: Lógica Inteligente con Canvas Hi-Res Estabilizado
*/

const RuletaHB = (function() {
  let anguloActual = 0;
  let girando = false;
  let canvas, ctx;
  let fase_hb = 0; 
  let autogiroInterval;
  let sectores = [];

  // CORRECCIÓN MATEMÁTICA: 320px (marco) - 16px (padding total) = 304px exactos
  const BASE_SIZE = 304; 

  function inicializar() {
    const dataElement = document.getElementById('ruleta-hb-data');
    if (!dataElement) return;

    // Sincronización Absoluta con el Panel de Shopify
    sectores = [
      { texto: dataElement.getAttribute('data-p1-texto'), codigo: dataElement.getAttribute('data-p1-codigo'), color: dataElement.getAttribute('data-p1-color'), t_color: dataElement.getAttribute('data-p1-tcolor') },
      { texto: dataElement.getAttribute('data-p2-texto'), codigo: dataElement.getAttribute('data-p2-codigo'), color: dataElement.getAttribute('data-p2-color'), t_color: dataElement.getAttribute('data-p2-tcolor') },
      { texto: dataElement.getAttribute('data-p3-texto'), codigo: dataElement.getAttribute('data-p3-codigo'), color: dataElement.getAttribute('data-p3-color'), t_color: dataElement.getAttribute('data-p3-tcolor') },
      { texto: dataElement.getAttribute('data-p4-texto'), codigo: dataElement.getAttribute('data-p4-codigo'), color: dataElement.getAttribute('data-p4-color'), t_color: dataElement.getAttribute('data-p4-tcolor') },
      { texto: dataElement.getAttribute('data-p5-texto'), codigo: dataElement.getAttribute('data-p5-codigo'), color: dataElement.getAttribute('data-p5-color'), t_color: dataElement.getAttribute('data-p5-tcolor') }
    ];

    canvas = document.getElementById('rh-canvas-ruleta');
    if (canvas) {
      ctx = canvas.getContext('2d');
      
      // Calibración Retina (Hi-DPI) Perfectamente Alineada
      const dpr = window.devicePixelRatio || 1;
      
      // Eliminamos el forzado de CSS por JS para que no desborde
      canvas.width = BASE_SIZE * dpr;
      canvas.height = BASE_SIZE * dpr;
      ctx.scale(dpr, dpr);

      dibujarRuleta();
      
      if (!localStorage.getItem('ruleta_hb_jugada')) {
        setTimeout(() => {
          document.getElementById('modal-ruleta-overlay').classList.remove('rh-oculto');
          iniciar_autogiro();
        }, 2000); 
      }
    }
  }

  function dibujarRuleta() {
    const radio = BASE_SIZE / 2;
    const centroX = BASE_SIZE / 2;
    const centroY = BASE_SIZE / 2;
    const arco = (2 * Math.PI) / sectores.length;

    ctx.clearRect(0, 0, BASE_SIZE, BASE_SIZE);

    for (let i = 0; i < sectores.length; i++) {
      const sector = sectores[i];
      
      ctx.fillStyle = sector.color;
      ctx.beginPath();
      ctx.moveTo(centroX, centroY);
      ctx.arc(centroX, centroY, radio, anguloActual + (i * arco), anguloActual + ((i + 1) * arco), false);
      ctx.fill();

      ctx.save();
      ctx.translate(centroX, centroY);
      ctx.rotate(anguloActual + (i * arco) + (arco / 2));
      ctx.textAlign = "right";
      ctx.textBaseline = "middle";
      ctx.fillStyle = sector.t_color;
      
      let fontsize = sector.texto.length > 18 ? "12px" : "15px";
      ctx.font = `900 ${fontsize} -apple-system, BlinkMacSystemFont, sans-serif`;

      // Ajuste proporcional del texto para el nuevo radio interior
      ctx.fillText(sector.texto, radio - 15, 0, radio - 65); 
      ctx.restore();
    }
  }

  function iniciar_autogiro() {
    fase_hb = 0;
    girando = true;
    const velocidadAutogiro = (Math.PI / 180) * 10; 
    autogiroInterval = setInterval(() => {
      anguloActual += velocidadAutogiro;
      dibujarRuleta();
    }, 16);
  }

  function accion_principal() {
    if (fase_hb === 0 && girando) { 
      forzar_parada_oportunidad();
    } else if (fase_hb === 1 && !girando) { 
      giro_final_ganador();
    }
  }

  function forzar_parada_oportunidad() {
    if (!girando || fase_hb !== 0) return;
    girando = false;
    fase_hb = 1;
    
    clearInterval(autogiroInterval);
    const btn = document.getElementById('rh-btn-principal-blue');
    btn.innerText = "FRENANDO...";
    btn.style.opacity = "0.7";
    btn.style.pointerEvents = "none";

    // El sector "1 Oportunidad más" ahora es el Espacio 3 (index 2)
    const arco = (2 * Math.PI) / sectores.length;
    const anguloCentroSegmento = (2 * arco) + (arco / 2);
    
    let anguloBase = anguloActual % (2 * Math.PI);
    let metaNorte = (3 * Math.PI / 2) - anguloCentroSegmento;
    if (metaNorte < anguloBase) metaNorte += 2 * Math.PI;

    const anguloInicial = anguloActual;
    const rotacionFinal = anguloActual + (metaNorte - anguloBase) + (3 * 2 * Math.PI); 
    
    let tiempoInicio = null;
    const tiempoGiro = 2800; 

    function animar(tiempoActual) {
      if (!tiempoInicio) tiempoInicio = tiempoActual;
      const progreso = tiempoActual - tiempoInicio;

      if (progreso < tiempoGiro) {
        const easeOut = 1 - Math.pow(1 - (progreso / tiempoGiro), 3);
        anguloActual = anguloInicial + (rotacionFinal - anguloInicial) * easeOut;
        dibujarRuleta();
        requestAnimationFrame(animar);
      } else {
        anguloActual = rotacionFinal;
        dibujarRuleta();
        btn.innerText = "¡GIRAR MI ÚLTIMA OPORTUNIDAD!";
        btn.style.opacity = "1";
        btn.style.pointerEvents = "auto";
      }
    }
    requestAnimationFrame(animar);
  }

  function giro_final_ganador() {
    if (girando || fase_hb !== 1) return;

    girando = true;
    fase_hb = 2;
    const btn = document.getElementById('rh-btn-principal-blue');
    btn.innerText = "GIRANDO POR ÚLTIMA VEZ...";
    btn.style.opacity = "0.5";
    btn.style.pointerEvents = "none";

    // El Premio Mayor ahora es el Espacio 1 (index 0)
    const arco = (2 * Math.PI) / sectores.length;
    const anguloCentroSegmento = (0 * arco) + (arco / 2);
    
    let anguloBase = anguloActual % (2 * Math.PI);
    let metaNorte = (3 * Math.PI / 2) - anguloCentroSegmento;
    if (metaNorte < anguloBase) metaNorte += 2 * Math.PI;

    const anguloInicial = anguloActual;
    const rotacionFinal = anguloActual + (metaNorte - anguloBase) + (5 * 2 * Math.PI); 

    let tiempoInicio = null;
    const tiempoGiro = 4000;

    function animar(tiempoActual) {
      if (!tiempoInicio) tiempoInicio = tiempoActual;
      const progreso = tiempoActual - tiempoInicio;

      if (progreso < tiempoGiro) {
        const easeOut = 1 - Math.pow(1 - (progreso / tiempoGiro), 3);
        anguloActual = anguloInicial + (rotacionFinal - anguloInicial) * easeOut;
        dibujarRuleta();
        requestAnimationFrame(animar);
      } else {
        anguloActual = rotacionFinal;
        dibujarRuleta();
        mostrar_ganador(sectores[0]);
      }
    }
    requestAnimationFrame(animar);
  }

  function mostrar_ganador(premio) {
    document.getElementById('rh-zona-cta').style.display = 'none';
    document.getElementById('rh-texto-premio-final').innerText = premio.texto;
    document.getElementById('rh-zona-exito').classList.remove('rh-oculto');

    if (typeof confetti === 'function') {
      confetti({ particleCount: 150, spread: 80, origin: { y: 0.5 }, zIndex: 9999999 });
    }

    fetch(`/discount/${premio.codigo}`)
      .then(() => { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
      .catch(error => { console.error("Error al enlazar el beneficio:", error); });

    localStorage.setItem('ruleta_hb_jugada', 'true');
    localStorage.setItem('habiram_estado_juego', 'ganador');
    localStorage.setItem('habiram_codigo_descuento', premio.codigo);
    localStorage.setItem('habiram_tiempo_expiracion', new Date().getTime() + (10 * 60000)); 
  }

  function cerrar() {
    if ((fase_hb === 1 || fase_hb === 2) && girando) {
      return; 
    }
    clearInterval(autogiroInterval);
    document.getElementById('modal-ruleta-overlay').classList.add('rh-oculto');
    localStorage.setItem('ruleta_hb_jugada', 'true');
  }

  function ir_catalogo() {
    window.location.href = '/collections/all';
  }

  document.addEventListener('DOMContentLoaded', inicializar);
  return { accion_principal, cerrar, ir_catalogo };
})();